<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div class="box" v-else>
      <div class="title" v-text="title"></div>
      <ul class="ScanCodeRecordBox">
        <li class="ScanCodeRecordRow" v-for="(item,index) in datas" v-bind:key="index">
          <i class="TraceDataDotBox"><i class="TraceDataDot"><i class="TraceDataDotTxt" v-text="index+1"></i></i></i>
          <i class="TraceDataLine " :class="{TraceDataLineTop:index == 0,TraceDataLineBottom:index == datas.length - 1}"></i>
          <p class="ScanCodeRecordAddress" v-if="item.address" v-text="item.address"></p>
          <p class="ScanCodeRecordAddress" v-else v-text="item.ip"></p>
          <p class="ScanCodeRecordDate" v-text="item.created_at"></p>
        </li>
      </ul>
      <div class="LoadMore NoSelect" @click="LoadMore" v-if="!NoMore"><span class="icon iconfont iconjiazai"></span>加载更多</div>
      <div class="LoadMore NoSelect" v-else>无更多信息</div>
    </div>

    <K-ModelLoading v-if="ModelLoading"></K-ModelLoading>
  </div>
</template>

<script>
var self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import ModelLoading from '@/components/ModelLoading.vue'
export default {
  name: 'ScanCodeRecord',
  components: {
    'K-Loading': Loading,
    'K-ModelLoading': ModelLoading
  },
  data () {
    return {
      page:1,
      code:null,
      title:"扫码记录",
      ModelLoading:false,
      NoMore:false,
      Loading:{
        type:1,
        txt:"数据请求中..."
      },
      datas:null
    }
  },
  created () {
    self = this;
    self.code = self.GetCode();
    self.etype = localStorage.getItem("wwm_etype");
    if(self.etype == 2){
      self.title = "查询记录";
    }
    self.GetRecord();
  },
  methods:{
    GetRecord () {
      var _url = "queryList/"
      if(self.etype == 2){
        _url = "queryVerifyList/";
      }
      axios.get(self.GetServerUrl(1)+_url + self.code+ "/" + self.page)
      .then(function (response){
        let datas = response.data.meta.data;
        for(let item in datas){
          if(datas[item].province){
            datas[item].address = datas[item].province;
            if(datas[item].city){
              datas[item].address += datas[item].city;
            }
          }

          //加载更多
          if(self.page > 1){
            self.datas.push(datas[item]);
          }
        }

        if(self.page > 1){
          self.ModelLoading = false;
        }else{
          self.datas = datas;
        }
      }).catch(function (error){
        console.log(error)
        if(self.page > 1){
          self.NoMore = true;
          self.ModelLoading = false;
        }else{
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        }

      })
    },
    LoadMore () {
      self.page++;
      self.ModelLoading = true;
      self.GetRecord();
    }
  }
}
</script>

<style scoped>
  .box{
    margin:.5rem;
    overflow: hidden;
    border-radius: .3rem;
    box-shadow: 0 0 5px rgba(100,100,100,0.2);
  }
  .title{
    font-weight: bold;
    padding:.5rem;
    font-size:.65rem;
    background-color: #FFF;
    border-bottom: 1px solid #F3F3F3;
  }
  .ScanCodeRecordBox{
    padding:.5rem;
    background-color: #FFF;
  }
  .ScanCodeRecordRow{
    padding-bottom:1.2rem;
    margin-bottom:5px;
    padding-left:2rem;
    position: relative;
    font-size:.58rem;
  }
  .ScanCodeRecordRow:last-child{
    padding-bottom:0;
  }
  .ScanCodeRecordDate{
    margin-top:.2rem;
    color:#666;
  }
  .TraceDataDotBox{
    display: block;
    position: absolute;
    left:0;
    top:.3rem;
    width:1rem;
    height:1.2rem;
    background-color: #FFF;
    z-index: 99;
  }
  .TraceDataDot{
    display: table;
    position: absolute;
    width:.8rem;
    height:.8rem;
    margin-top:.12rem;
    border:2px solid #2C5DE8;
    border-radius:.8rem;
    z-index: 99;
    color:#2C5DE8;
    text-align: center;
  }
  .TraceDataDotTxt{
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    font-weight: 500;
  }
  .TraceDataLine{
    display: block;
    position: absolute;
    top:0;
    bottom:0;
    left:.45rem;
    border-left: 2px dashed #2C5DE8;
    z-index: 98;
  }
  .TraceDataLineTop{
    top:.3rem;
  }
  .TraceDataLineBottom{
    bottom:.5rem;
  }
  .LoadMore{
    font-size:.6rem;
    padding:.35rem 0 .5rem 0;
    background-color: #FFF;
    text-align: center;
    border-top: 1px solid #F3F3F3;
  }
  .iconjiazai{
    position: relative;
    top:.1rem;
    font-size:.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/public-view/ScanCodeRecord.vue